module.exports = __webpack_public_path__ + "img/9_b.b0fd4c9a.jpg";